import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const DurchfuehrungAbschlussStartUp: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Durchführung des Vorhabens" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default DurchfuehrungAbschlussStartUp;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0265758334_er_Der_Planungggf_Erlaeutern,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0208945182_An_Den_Zeitlichen_Ablaufplan,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0266839572_Zielgruppen_Aufgeschluesselt,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0067204094_Angebote_Unterstuetzt_Haben,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0108009140_Reichweiteregionalhessenweit,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucDurchfuehrungAbschlussStartUp = () => {
	return concat(formStruc());
};
